import { useCurrency } from "../../utils/helpers";

export const resultDropdownOptions = [
  { value: "Complete Microgrid", label: "Complete Microgrid" },
  {
    value: "Reference Load Only",
    label: "Reference Load Only",
    disabled: true,
  },
  {
    value: "Reference Genset Only",
    label: "Reference Genset Only",
    disabled: true,
  },
  {
    value: "Reference Renewables Only",
    label: "Reference Renewables Only",
    disabled: true,
  },
  {
    value: "Reference Load EVCS",
    label: "Reference Load EVCS",
    disabled: true,
  },
  {
    value: "Reference Simple Control Battery",
    label: "Reference Simple Control Battery",
    disabled: true,
  },
];

export const buttons = [
  "Compare All",
  "Export Report",
  "Export Configuration",
  "Export Time Series",
];

export const tabList = [
  // "Highlights",
  // "Energy Balance",
  // "Synthesis",
  // "Time Series",
  // "Cash Flow",
  // "Assets",
];

export const formatValueToPercentage = (value) => {
  if(!value){
    return 0;
  }
  const strValue = value.toString();
  if (strValue.includes("-")) {
    return parseFloat(strValue) * -1;
  } else {
    return parseFloat(strValue);
  }
};

export const ATTRIBUTES_LABELS = {
  IRR: "Internal Rate Of Return (%)",
  ROI: "Return On Investment (%)",
  ROIDiscounted: "Return On Investment Discounted (%)",
  PaybackTime: "Payback Time (Years)",
  PaybackDiscounted: "Payback Discounted (Years)",
  RenewFraction: "Renew Fraction (%)",
  NPC: "Net Present Cost ({currency})",
  NPCVariation: "Net Present Cost Variation ({currency})",
  AnnCost: "Annual Cost ({currency})",
  AnnCostVariation: "Annual Cost Variation ({currency})",
  LCOE: "Levelized Cost of Energy ({currency}/kWh)",
  LCOS: "Levelized Cost of Storage ({currency}/kWh)",
  OpCost: "Operation Cost ({currency})",
  OpCostVariation: "Operation Cost Variation ({currency})",
  Capital: "Capital ({currency})",
  AutoProd: "Auto - Production (%)",
  AutoCons: "Auto - Consumption (%)",
  PositiveEnergy: "Positive Energy (%)",
  LocalCO2: "Local CO2 (kg)",
  GridCO2: "Grid CO2 (kg)",
  ThermalSupplyCO2: "Thermal Supply CO2 (kg)",
  UnmetEnergyOffgrid: "Unmet Energy Off Grid (kWh)",
  UnmetEnergyGridConnected: "Unmet Energy OnGrid (kWh)",
  ExcessEnergyOffgrid: "Excess Energy OffGrid (kWh)",
  ExcessEnergyGridConnected: "Excess Energy Grid Connected (kWh)",
};

// Return a labels object replacing hardcoded `$` with the provided currency string.
export const getAttributesLabels = (currency = "$", gridType) => {
  const replaceCurrency = (s) => {
    if (typeof s !== 'string') return s;
    return s.replace(/\{currency\}/g, currency);
  };
  const obj = {};
  Object.keys(ATTRIBUTES_LABELS).forEach((k) => {
    obj[k] = replaceCurrency(ATTRIBUTES_LABELS[k]);
  });
  if (gridType === "OFF_GRID") {
    obj.UnmetEnergyOffgrid = "Unmet Energy (kWh)";
    obj.ExcessEnergyOffgrid = "Excess Energy (kWh)";
  }
  return obj;
};

// React hook convenience: returns labels using `useCurrency()` from helpers.
// Consumers in React components can call this hook to get currency-aware labels.
export const useAttributesLabels = (gridType) => {
  const currency = useCurrency();
  return getAttributesLabels(currency, gridType);
};
